import { put, takeLatest } from "redux-saga/effects";
import {
  GET_REGION,
  GET_REGION_INIT,
  GET_REGION_SUCCESS,
  GET_REGION_FAILED,
  FOLLOW_FUND,
  FOLLOW_FUND_INIT,
  FOLLOW_FUND_SUCCESS,
  FOLLOW_FUND_FAILED,
  GET_STRATEGY,
  GET_STRATEGY_INIT,
  GET_STRATEGY_SUCCESS,
  GET_STRATEGY_FAILED,
  GET_SUBSPECIALTY_INIT,
  GET_SUBSPECIALTY_SUCCESS,
  GET_SUBSPECIALTY_FAILED,
  GET_SUBSPECIALTY,
  CREATE_RECOMMENDFUND_INIT,
  CREATE_RECOMMENDFUND_SUCCESS,
  CREATE_RECOMMENDFUND_FAILED,
  CREATE_RECOMMENDFUND,
  SEARCH_HEDGEFUND,
  SEARCH_HEDGEFUND_INIT,
  SEARCH_HEDGEFUND_SUCCESS,
  SEARCH_HEDGEFUND_FAILED,
} from "./constants";
import { getUtil, postUtil } from "../../services/axiosClient";
import { API } from "../../utils/Constant";
import GenerateUrl from "@hedgefund/shared/src/GenerateUrl";


const getFundParams = [
  { keyword: "Keyword", value: "keyword" },
  { keyword: "StrategyId", value: "strategy" },
  { keyword: "SubSpecialtyId", value: "subSpecialty" },
  { keyword: "RegionId", value: "region" },
  { keyword: "status", value: "status" },
  { keyword: "MinValMonthlyReturn", value: "minMonthlyReturn" },
  { keyword: "MaxValMonthlyReturn", value: "maxMonthlyReturn" },
  { keyword: "MinVal", value: "min" },
  { keyword: "MaxVal", value: "max" },
  { keyword: "page", value: "page" },
  { keyword: "perPage", value: "perPage" },
  { keyword: "sortBy", value: "sortBy" },
  { keyword: "sortByColumn", value: "sortByColumn" },
];


export function* searchHedgeFund({ payload }) {

  yield put({ type: SEARCH_HEDGEFUND_INIT });
  try {
    let url = API.SearchHedgeFund + GenerateUrl(payload, getFundParams);
    const res = yield getUtil(url);
    if (res?.status === 200) {
      const { data } = res;

      yield put({ type: SEARCH_HEDGEFUND_SUCCESS, payload: data.result });
    } else {
      yield put({ type: SEARCH_HEDGEFUND_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* getStrategies() {
  yield put({ type: GET_STRATEGY_INIT });
  try {
    const res = yield getUtil(API.FundAssociatedStrategies);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: GET_STRATEGY_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_STRATEGY_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* getRegion() {
  yield put({ type: GET_REGION_INIT });
  try {
    const res = yield getUtil(API.GetRegion);
    if (res?.status === 200) {
      const { data } = res;

      yield put({ type: GET_REGION_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_REGION_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* followFund({ fundId, follow, onSuccess }) {
  const payload = {
    fundId,
    follow,
  };
  yield put({ type: FOLLOW_FUND_INIT });
  try {
    const res = yield postUtil(API.FollowFund, payload);
    if (res?.status === 200) {
      if (onSuccess) onSuccess();
      yield put({ type: FOLLOW_FUND_SUCCESS, payload: { fundId, follow } });
    } else {
      yield put({ type: FOLLOW_FUND_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}
export function* getSubspecialties(payload) {
  yield put({ type: GET_SUBSPECIALTY_INIT });
  try {
    const res = yield getUtil(API.SubSpecialties);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: GET_SUBSPECIALTY_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_SUBSPECIALTY_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* CreateRecommendedFund({ payload, onSuccess, onModalClose }) {
  yield put({ type: CREATE_RECOMMENDFUND_INIT });
  try {
    const res = yield postUtil(`${API.CreateRecommendedFund}`, payload);
    if (res?.status === 200) {
      const { data } = res;
      yield put({
        type: CREATE_RECOMMENDFUND_SUCCESS,
        payload: data.result,
      });
      if (data.result !== null) {
        onModalClose()
        onSuccess();
      }
    } else {
      yield put({ type: CREATE_RECOMMENDFUND_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}


export function* SearchHedgeFundSaga() {
  yield takeLatest(SEARCH_HEDGEFUND, searchHedgeFund);
  yield takeLatest(GET_REGION, getRegion);
  yield takeLatest(FOLLOW_FUND, followFund);
  yield takeLatest(GET_STRATEGY, getStrategies);
  yield takeLatest(GET_SUBSPECIALTY, getSubspecialties);
  yield takeLatest(CREATE_RECOMMENDFUND, CreateRecommendedFund);

}
